import ScrollToTop from "react-scroll-to-top";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import ProductMenu from "../components/ProductMenu";

function Menu() {
	return (
		<div className="menu">
			<Navbar />
			<Hero
				title="DÉCOUVREZ LA CARTE"
				subtitle="Cocktails & Spiriteux"
				image="/assets/hero/carte.png"
			/>
			<ProductMenu />
			<Footer />
		</div>
	);
}

export default Menu;
